export const fadeUp = {
    hidden: { opacity: 0, y: 32 },
    visible: { opacity: 1, y: 0 },
};

export const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
};

export const scaleIn = {
    hidden: { opacity: 0, scale: 0.94 },
    visible: { opacity: 1, scale: 1 },
};

export const slideInLeft = {
    hidden: { opacity: 0, x: -28 },
    visible: { opacity: 1, x: 0 },
};

export const slideInRight = {
    hidden: { opacity: 0, x: 28 },
    visible: { opacity: 1, x: 0 },
};

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.1, delayChildren: 0.05 },
    },
};

export const defaultTransition = {
    duration: 0.55,
    ease: [0.22, 0.8, 0.22, 1],
};

export const springTransition = {
    type: "spring",
    stiffness: 380,
    damping: 28,
};

export const viewport = {
    once: true,
    margin: "-60px 0px -80px 0px",
};
